/**
 * POST /auth/stop-impersonate - Stop impersonating and restore admin session
 */

import type { ActionDefinition } from '@gzl10/nexus-sdk'
import type { MiddlewareHandler } from 'hono'
import type { AuthService } from '../auth.service.js'
import { getRequestInfo } from './helpers.js'

export const stopImpersonateAction: ActionDefinition = {
  key: 'stop-impersonate',
  label: { en: 'Stop Impersonating', es: 'Dejar de suplantar' },
  icon: 'mdi:account-switch-outline',
  scope: 'module',
  group: { en: 'Sessions', es: 'Sesiones' },
  // Disabled when user is not currently impersonating.
  disabled: (_ctx, c) => {
    const imp = c?.get('impersonation') as { isImpersonating?: boolean } | undefined
    return !imp?.isImpersonating
  },
  disabledReason: { en: 'Not currently impersonating any user', es: 'No está suplantando a ningún usuario' },
  method: 'POST',
  middleware: (ctx) => [
    ctx.core.middleware['auth'] as MiddlewareHandler,
    (ctx.services.get('authRateLimits') as { admin: MiddlewareHandler }).admin
  ],
  handler: async (ctx, _input, c) => {
    const impersonation = c?.get('impersonation') as { isImpersonating?: boolean; originalUserId?: string } | undefined

    if (!impersonation?.isImpersonating || !impersonation.originalUserId) {
      throw new ctx.core.errors.ForbiddenError('Not currently impersonating')
    }

    const authService = ctx.services.get<AuthService>('auth')
    return authService.stopImpersonate(impersonation.originalUserId, getRequestInfo(c))
  }
}
